// extracted by css-extract-rspack-plugin
var _1 = "bW8LoItXLoYfQl5A";
var _2 = "t7gi1MyJ_EoAyiy4";
export { _1 as "noMoreItems", _2 as "noMoreItemsIcon" }
// extracted by css-extract-rspack-plugin
var _1 = "bW8LoItXLoYfQl5A";
var _2 = "t7gi1MyJ_EoAyiy4";
export { _1 as "noMoreItems", _2 as "noMoreItemsIcon" }
